import React, { useState } from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col
} from 'reactstrap'
import _ from 'lodash'
import NumberFormat from "react-number-format"

import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import CurrencySettings from 'utils/currencies'

const Update = ({
  showUpdateMedicine,
  selectedMedicine,
  onChangeMedicineHOC,
  onLoadMedicines,
  updateMedicine
}) => {

  const onChangeMedicineData = ( key, val ) => {
    let tmp = _.cloneDeep( selectedMedicine )
    tmp[ key ] = val
    return onChangeMedicineHOC( 'selectedMedicine', tmp )
  }

  return (
    <Modal
      isOpen={ showUpdateMedicine }
      size={ 'xl' }
      toggle={() => {
        onChangeMedicineHOC( 'showUpdateMedicine', false )
      }}>
      <ModalHeader toggle={() => onChangeMedicineHOC( 'showUpdateMedicine', false )}>Update medicine</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>Name</Label>
            <Input 
              type="text"
              value={ selectedMedicine.name }
              onChange={ e => {
                onChangeMedicineData( 'name', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>Stocks</Label>
            <Input 
              type="number"
              value={ selectedMedicine.stocks }
              onChange={ e => {
                onChangeMedicineData( 'stocks', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>{`Price per unit - ${ CurrencySettings() }`}</Label>
            <NumberFormat
              className="form-control"
              value={ selectedMedicine.price_per_unit }
              thousandSeparator={ "," }
              decimalSeparator={ "." }
              onValueChange={( values ) => {
                const { formattedValue, value } = values;
                onChangeMedicineData( 'price_per_unit', value )
              }}
              inputMode="numeric"
              displayType="input"
            />
          </FormGroup>
        </Form>
        { onLoadMedicines && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={() => {
            updateMedicine( selectedMedicine )
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default Update